<template>
  <div class="modal cart-modal" v-if="$parent.cartModalIsVisible">
    <div class="overlay" @click="$parent.closeCartModal"></div>
    <div class="wrapper">
      <div class="container">
        <img
          class="close"
          @click="$parent.closeCartModal"
          src="./../img/close.svg"
        />
        <div class="modal-header">
          <div class="title">CART</div>
        </div>
        <div class="cart-content">
          <div class="cart-items" v-if="$parent.cartContents.length">
            <div
              class="cart-item"
              v-for="(item, i) in $parent.cartContents"
              :key="i"
            >
              <img :src="imgDomain + item.img" class="item-image" />
              <div class="item-info">
                <div class="item-name">{{ item.title }}</div>
                <div class="item-type">{{ getItemType(item) }}</div>
              </div>
              <div class="item-price">
                <div class="price-coins">
                  <span class="price-value">{{ item.price }}</span>
                  <img src="../img/coin.svg" class="coin-icon" />
                </div>
                <div class="price-currency">
                  {{ item.price }} {{ $parent.currency }}
                </div>
              </div>
              <button
                class="remove-button"
                @click="$parent.removeFromCart(item.item_id)"
              >
                <img src="../img/trash.svg" class="remove-icon" />
                <img src="../img/trashhover.svg" class="remove-icon-hover" />
              </button>
            </div>
          </div>
          <div class="cart-empty" v-else>
            <div class="empty-text">Your cart is empty</div>
          </div>
          <div class="payment-section">
            <div class="payment-title">PAYMENT</div>
            <div class="total-section">
              <div class="total-text">
                TOTAL: <span class="total-amount">{{ $parent.totalSum }}</span>
                <img src="../img/coin.svg" class="coin-icon" />
                <span class="total-currency">/ {{ $parent.totalSum }} {{ $parent.currency }}</span>
              </div>
            </div>
            <button class="buy-button" @click="$parent.openOrderCartModal()">
              BUY
            </button>
            <div class="balance-section">
              <div class="balance-label">MY BALANCE</div>
              <div class="balance-value">
                <img src="../img/hederkooshel.svg" class="wallet-icon" />
                <span class="balance-amount">{{ Math.floor(($parent.profileData.balance || 0) * 100) / 100 }}</span>
                <img src="../img/coin.svg" class="coin-icon" />
                <img src="../img/plusheder.svg" class="plus-icon" @click="$parent.openTopUpModal" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartModal",
  props: ["currency"],
  data: function () {
    return {
      imgDomain: process.env.VUE_APP_STATIC_DOMAIN || "",
    };
  },
  methods: {
    getItemType(item) {
      // Определяем тип товара на основе категории или других данных
      if (item.category && typeof item.category === 'object') {
        return item.category.name || item.category.text || 'Item';
      }
      if (item.category && typeof item.category === 'string') {
        return item.category;
      }
      if (item.category_name) {
        return item.category_name;
      }
      return "Item";
    },
  },
};
</script>

